/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* Section - tabbed content switcher */

  document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.product-tabs__trigger');
    
    tabs.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        const container = e.target.closest('.product-tabs__wrapper');
        const targetId = e.target.getAttribute('data-tab-target');

        // Reset all triggers and panels in THIS specific section
        container.querySelectorAll('.product-tabs__trigger').forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        container.querySelectorAll('.product-tabs__panel').forEach(p => p.classList.remove('is-active'));

        // Activate current
        e.target.classList.add('is-active');
        e.target.setAttribute('aria-selected', 'true');
        document.getElementById(targetId).classList.add('is-active');
      });
    });
  });
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
